import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

const LOJA = "Giraia Bike Shop";
const EMAIL = "giragirabike@gmail.com";
const WHATSAPP = "(66) 99958-4198";
const ENDERECO = "Avenida Ademar Raiter, 438, Sorriso - MT";
const DATA = "14 de outubro de 2026";

function Secao({ titulo, children }) {
  return (
    <section>
      <h2 className="text-[#E2B84A] text-xl font-black mt-5 mb-2">{titulo}</h2>
      {children}
    </section>
  );
}

const PrivacidadePage = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-[#E7E3EC]">
      <div className="max-w-3xl mx-auto p-6">
        <Link to="/" className="inline-flex items-center gap-2 text-[#E2B84A] mb-6 text-sm font-bold">
          <ArrowLeft size={18} /> Voltar
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <Shield className="w-8 h-8 text-[#E2B84A]" />
          <h1 className="text-4xl font-black text-white">Política de Privacidade</h1>
        </div>
        <p className="text-[#716A80] text-sm mb-8">Atualizado em {DATA} · Conformidade com a LGPD (Lei nº 13.709/2018)</p>
        <div className="space-y-5 text-sm leading-relaxed">
          <section className="bg-[#E2B84A]/10 border border-[#E2B84A]/40 rounded-lg p-4">
            <p><strong className="text-[#E2B84A]">Resumo rápido:</strong> Coletamos seus dados só para vender, atender e oferecer o curso. Não vendemos seus dados. Você pode pedir acesso ou exclusão a qualquer momento.</p>
          </section>
          <Secao titulo="1. Quem somos">
            <p>{LOJA} · {ENDERECO}. Contato: {EMAIL} · WhatsApp {WHATSAPP}.</p>
          </Secao>
          <Secao titulo="2. Dados que coletamos">
            <p>Nome, e-mail, telefone e senha (guardada de forma criptografada). Dados da compra do curso: módulo escolhido, valor e data. Seu progresso e seus certificados. O site guarda no seu navegador uma chave de acesso para manter você conectado.</p>
          </Secao>
          <Secao titulo="3. Para que usamos">
            <p>Criar sua conta, gerar o PIX e liberar os módulos comprados, emitir certificados, responder pelo WhatsApp e cumprir obrigações fiscais.</p>
          </Secao>
          <Secao titulo="4. Base legal">
            <p>Execução de contrato (compra e curso), consentimento (cadastro e contato) e obrigação legal (fiscal).</p>
          </Secao>
          <Secao titulo="5. Pagamentos">
            <p>Os pagamentos são feitos por PIX. Não coletamos dados de cartão nem acesso à sua conta bancária. O módulo é liberado depois que conferimos o pagamento.</p>
          </Secao>
          <Secao titulo="6. Compartilhamento">
            <p>Não vendemos nem alugamos seus dados. Usamos provedores de hospedagem e de envio de e-mail apenas para o site funcionar, e podemos informar autoridades quando a lei exigir.</p>
          </Secao>
          <Secao titulo="7. Menores de 18 anos">
            <p>Menores de 18 anos devem se cadastrar com ciência e autorização de um responsável, que pode pedir a exclusão dos dados a qualquer momento.</p>
          </Secao>
          <Secao titulo="8. Por quanto tempo guardamos">
            <p>Enquanto sua conta estiver ativa. Registros de compras ficam por até 5 anos por exigência fiscal; depois, são apagados ou anonimizados.</p>
          </Secao>
          <Secao titulo="9. Seus direitos">
            <p>Você pode pedir confirmação, acesso, correção, exclusão, portabilidade ou revogar o consentimento. Escreva para {EMAIL} ou chame no WhatsApp {WHATSAPP}. Respondemos em até 15 dias.</p>
          </Secao>
          <Secao titulo="10. Segurança">
            <p>Usamos conexão segura (HTTPS), senhas criptografadas e acesso restrito aos dados. Se houver um incidente relevante, avisaremos você e a ANPD.</p>
          </Secao>
        </div>
      </div>
    </div>
  );
};

export default PrivacidadePage;
